// extracted by mini-css-extract-plugin
export var root = "SidebarTreeList-module--root--ks2of";
export var serif = "SidebarTreeList-module--serif--GK6Ey";